<template>
  <div class="editor" v-html="returnText(termsText)"></div>
</template>

<script>
import termsUtil from "@/components/terms/termsUtil";
import util from "@/mixins/util"

export default {
  name: "TermsComponent",
  mixins: [termsUtil],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    termsType: {}
  },
  data() {
    return {
      divisionType: '',
      termsKey: '',
      termsText: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.gerTerms();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let config = this.returnTermsConfig(this.termsType);
      this.divisionType = config.divisionType;
      this.termsKey = config.termsKey;
    },
    gerTerms() {
      let params = {
        ty: this.divisionType,
      }
      try {
        this.$api.$config.getConfig(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type != 1) {
            this.errorAlert('약관을 찾을수 없습니다.');
            return false;
          } else {
            let config = res.List[0];
            this.termsText = util.htmlDecode(config[this.termsKey]);

          }
        })
      } catch (e) {
        console.log(e);
      }
    },
    returnText(text) {
      if (util.isEmpty(text)) {
        return '';
      }
      return text.replace(/(\n|\r\n)/g, '<br>');
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>